import { GetApiCall, PutApiCall } from './axiosSetup';

export const GET_PLAYER_MESSAGES = '/Message/get-player-messages';
export const GET_MESSAGE_DETAILS = '/Message/get-message-details';
export const UPDATE_MESSAGE_STATUS = '/Message/update-message-status';

const VALID_STATUSES = ['unread', 'deleted', 'read', 'received'];

export const getPlayerMessages = async (playerId) => {
  const data = await GetApiCall(GET_PLAYER_MESSAGES, undefined, {
    pid: playerId,
    skinId: 1,
    moneyType: 'funAndReal',
    clientType: 'download',
  });
  return Array.isArray(data) ? data : [];
};

export const getMessageDetails = async (messageId) =>
  GetApiCall(GET_MESSAGE_DETAILS, undefined, { messageId });

export const updateMessageStatus = async ({
  messageId,
  playerId,
  skinId = 1,
  status,
}) => {
  if (!VALID_STATUSES.includes(status)) {
    throw new Error(`Invalid message status: ${status}`);
  }

  const query = new URLSearchParams({
    messageId: String(messageId),
    playerId: String(playerId),
    skinId: String(skinId),
    status,
  }).toString();

  return PutApiCall(`${UPDATE_MESSAGE_STATUS}?${query}`, {});
};